import request from "@/utils/request";

const login = {
    
    get: (data) => {
        return request({
            url: '/users/login',
            method: 'POST',
            data
        })
    },
    out: (data) => {
        return request({
            url: '/users/logout',
            method: 'GET',
            data
        })
    },
    auth: (data) => {
        return request({
            url: '/users/auth',
            method: 'POST',
            data
        })
    },
    forget: (data) => {//修改密码
        return request({
            url: 'users/forget',
            method: 'POST',
            data
        })
    },
}
export default login;